<template>
    <div class="modal fade register-success" id="registrationSuccess" tabindex="-1" role="dialog" aria-labelledby="registrationSuccessLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
            <div class="modal-body">
                <h5 class="modal-title" role="status">Email has been sent to verify your account</h5>
                <ColoredButton class="mt-3" data-bs-dismiss="modal" @click="$router.push('/')">OK</ColoredButton>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        computed: {
            contactDetails() {
                return this.$store.getters['GET_FOOTER_SETTINGS']; 
            }
        },
        mounted() {
            this.$store.dispatch('footerSettings');
        }
    }
</script>